export const delayPromiseResult = (seconds: number, rejected: boolean): Promise<any> =>
  new Promise((resolve, reject): void => {
    if (rejected) {
      setTimeout(reject, seconds * 1000);
    } else {
      setTimeout(resolve, seconds * 1000);
    }
  });
